/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the A260/A280 ratio?`)
};

const es_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es la relación A260/A280?`)
};

const de_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist das A260/A280-Verhältnis?`)
};

const nl_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de A260/A280-ratio?`)
};

const fr_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le ratio A260/A280 ?`)
};

const it_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è il rapporto A260/A280?`)
};

const pt_br2_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a razão A260/A280?`)
};

const pt_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é o rácio A260/A280?`)
};

const ja_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260/A280比とは何ですか？`)
};

const zh_od_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260/A280 比值是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_faq_q3", locale)
	if (locale === "en") return en_od_faq_q3(inputs)
	if (locale === "es") return es_od_faq_q3(inputs)
	if (locale === "de") return de_od_faq_q3(inputs)
	if (locale === "nl") return nl_od_faq_q3(inputs)
	if (locale === "fr") return fr_od_faq_q3(inputs)
	if (locale === "it") return it_od_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_od_faq_q3(inputs)
	if (locale === "pt") return pt_od_faq_q3(inputs)
	if (locale === "ja") return ja_od_faq_q3(inputs)
	return zh_od_faq_q3(inputs)
};